import React, { useEffect, useState } from "react";
import CourseAssignmentSelect from "./CourseAssignmentSelect";
import {
  ResolvedCourse,
  searchCourses,
  toResolvedCourse,
} from "./quizCourseAssignment";

type Props = {
  value?: number;
  onChange?: (courseId: number | undefined) => void;
};

const LOADING_TITLE = "Cargando…";
const NOT_FOUND_TITLE = "Curso no encontrado";

const coursesById = new Map<number, Promise<ResolvedCourse | null>>();

export const findCourseById = (id: number): Promise<ResolvedCourse | null> => {
  const cached = coursesById.get(id);
  if (cached) return cached;
  const lookup = searchCourses({ id, limit: 1 })
    .then((courses) => {
      const course = courses.find((candidate) => candidate.id === id);
      return course ? toResolvedCourse(course) : null;
    })
    .catch(() => {
      coursesById.delete(id);
      return null;
    });
  coursesById.set(id, lookup);
  return lookup;
};

const placeholderCourse = (id: number, title: string): ResolvedCourse => ({
  id,
  title,
  clave: null,
});

const ExamCourseSelect: React.FC<Props> = ({ value, onChange }) => {
  const [course, setCourse] = useState<ResolvedCourse | null>(null);
  const courseId = course?.id;

  useEffect(() => {
    if (value === undefined || courseId === value) return;
    let active = true;
    findCourseById(value).then((found) => {
      if (active) setCourse(found ?? placeholderCourse(value, NOT_FOUND_TITLE));
    });
    return () => {
      active = false;
    };
  }, [value, courseId]);

  const shown =
    value === undefined
      ? null
      : course?.id === value
        ? course
        : placeholderCourse(value, LOADING_TITLE);

  return (
    <CourseAssignmentSelect
      value={shown}
      onChange={(next) => {
        setCourse(next);
        onChange?.(next?.id);
      }}
    />
  );
};

export default ExamCourseSelect;
